/**
 *  Slider script file
**/
import formattersMixin from '@/filters/customFormatters'

export default {
  name: 'Slider',
  mixins: [formattersMixin],
  components: {},
  props: {
    value: {
      type: Number,
      required: false,
      default: 0
    },
    min: {
      type: Number,
      required: false,
      default: 0
    },
    max: {
      type: Number,
      required: false,
      default: 100
    },
    tooltip: {
      type: Boolean,
      default: true,
      required: false
    },
    unit: {
      type: String,
      requried: false
    }
  },
  data () {
    return {
      isDragging: false,
      sliderWidth: 0,
      thumbWidth: 0
    }
  },
  computed: {
    thumbStyles () {
      return {
        transform: `translate3d(${this.position}px, -50%, 0)`
      }
    },
    backgroundStyles () {
      return {
        backgroundImage: `linear-gradient(90deg, #16969d ${this.percent}%, #e4e5e8 ${this.percent}%)`
      }
    },
    range () {
      return this.max - this.min
    },
    percent () {
      return ((this.value - this.min) / this.range) * 100
    },
    position () {
      return this.sliderWidth * (this.percent / 100)
    }
  },
  mounted () {
    this.$refs.slider.addEventListener('mousedown', this.onDragStart, false)
    this.$refs.slider.addEventListener('touchstart', this.onDragStart, false)
    this.sliderWidth = this.$refs.slider.offsetWidth
    this.thumbWidth = this.$refs.thumb.offsetWidth
  },
  beforeDestroy () {
    this.removeListeners()
  },
  methods: {
    onDragStart (ev) {
      ev.stopPropagation()
      this.isDragging = true
      this.setupListeners()
    },
    onDragMove (ev) {
      if (!this.isDragging) {
        return
      }
      ev.stopPropagation()
      ev.preventDefault()
      if (ev.target === this.$refs.slider || !this.$refs.slider.contains(ev.target)) {
        const position = ev.type === 'touchmove' ? ev.touches[0].offsetX : ev.offsetX
        const newVal = this.valueFromPosition(position)
        this.$emit('change', newVal.toFixed())
      }
    },
    onDragEnd (ev) {
      ev.stopPropagation()
      this.isDragging = false
      this.removeListeners()
      this.$emit('end')
    },
    setupListeners () {
      document.addEventListener('mousemove', this.onDragMove, false)
      document.addEventListener('touchmove', this.onDragMove, false)
      document.addEventListener('mouseup', this.onDragEnd, false)
      document.addEventListener('touchend', this.onDragEnd, false)
    },
    removeListeners () {
      document.removeEventListener('mousemove', this.onDragMove, false)
      document.removeEventListener('touchmove', this.onDragMove, false)
      document.removeEventListener('mouseup', this.onDragEnd, false)
      document.removeEventListener('touchend', this.onDragEnd, false)
    },
    valueFromPosition (pos) {
      const margin = this.thumbWidth / 2
      pos = pos - margin
      if (pos < 0) {
        pos = 0
      }
      if (pos > this.sliderWidth) {
        pos = this.sliderWidth
      }
      const relativeVal = (pos / this.sliderWidth)
      return (relativeVal * this.range) + this.min
    }
  }
}
